import Turbolinks from "turbolinks";

export default class ChatDocumentManager {
  constructor(shipmentId) {
    this.shipmentId = shipmentId;
    this.reinitialize();
  }

  reinitialize() {
    this.typeChangeListener();
    this.assignDocumentListener();
  }

  typeChangeListener() {
    $("#chat-container .assign-type").on("change", (e) => {
      const types = JSON.parse(document.getElementById("chat_document_types").value);
      let select = e.currentTarget;
      let values = select.value;

      const shipmentLvlOptions = types.filter((x) => x.shipment_level).map((x) => `${x.id}`);
      const containerLvlOptions = types.filter((x) => x.container_level).map((x) => `${x.id}`);
      const isShipmentLvl = !!shipmentLvlOptions.filter((element) => values.includes(element))
        .length;
      const isContainerLvl = !!containerLvlOptions.filter((element) => values.includes(element))
        .length;

      let objectSelect = $(select).parents(".attachment").find(".assign-object");
      objectSelect.find("option").remove();

      let objectOptionsArr = [];
      if (isShipmentLvl) {
        objectOptionsArr.push(["shipment", "Shipment"]);
      }
      if (isContainerLvl) {
        objectSelect.data().containers.forEach((x) => objectOptionsArr.push(x));
      }
      objectOptionsArr.forEach((x) => {
        objectSelect.append(`<option value="${x[0]}">${x[1]}</option>`);
      });
    });
  }

  assignDocumentListener() {
    $("#submit-assigned-document").on("click", (_e) => {
      let toUpdateDocuments = [];

      $(".attachment").each(function () {
        const attachment = $(this);
        var containers = attachment.find(".assign-object").val();
        const types = attachment.find(".assign-type").val();

        if (containers.includes("shipment")) {
          containers = attachment
            .find(".assign-object")
            .data()
            .containers.map((x) => x[0]);
        }
        if (types.length && containers.length) {
          toUpdateDocuments.push({
            attachment_id: attachment.data("id"),
            document_type_ids: types,
            container_ids: containers,
          });
        }
      });

      if (toUpdateDocuments.length) {
        $.post(
          `/admin/shipments/${this.shipmentId}/assign_chat_documents`,
          { data: toUpdateDocuments },
          () => Turbolinks.visit(document.location)
        );
      }
    });
  }
}
